import Axios from "../../utils/axios";
export const getBibleCountryLanguages = (payload) => {
  const URL = "/bible/countries";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const getBibleLanguages = (payload) => {
  const URL = "/bible/languages";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const getBibleVersions = (payload) => {
  const URL = "/bible/biblesforlanguage";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const getVersionBooks = (payload) => {
  const URL = "/bible/bibledata";
  return Axios.post(URL, payload).then((res) => res.data);
};
// API function for getJournals
export const getJournals = (payload) => {
  const URL = "/journal/read";
  return Axios.post(URL, payload).then((res) => res.data);
};
export const getChapterDetails = (payload) => {
  const URL = "/bible/biblebookdata";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const getBibleSearch = (payload) => {
  const URL = "/searchbible";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const getChapterVideos = (payload) => {
  const URL = "/chapter/twgvideos/read";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const saveChapterVideos = (payload) => {
  const URL = "/chapter/videos/save";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const deleteChapterVideos = (payload) => {
  const URL = "/chapter/videos/remove";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const getChapterJournals = (payload) => {
  const URL = "/chapter/twgjournals/read";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const saveChapterJournals = (payload) => {
  const URL = "/chapter/journals/save";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const deleteChapterJournals = (payload) => {
  const URL = "/chapter/journals/remove";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const getVerseDetails = (payload) => {
  const URL = "/verse/read";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const getSpeaker = (payload) => {
  const URL = "/journal/speaker/readcms";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const saveSpeakerDetails = (payload) => {
  const URL = "/journal/speaker/save";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const updateSpeakerDetails = (payload) => {
  const URL = "/journal/speaker/update";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const deleteSpeaker = (payload) => {
  const URL = "/journal/speaker/delete";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const getJournalCategories = (payload) => {
  const URL = "/journal/category/readcms";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const saveJournalCategoriesDetails = (payload) => {
  const URL = "/journal/category/save";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const updateJournalCategoriesDetails = (payload) => {
  const URL = "/journal/category/update";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const deleteJournalCategories = (payload) => {
  const URL = "/journal/category/delete";
  return Axios.post(URL, payload).then((res) => res.data);
};

//Plan APIs

export const getPlans = (payload) => {
  const URL = "/plans/read";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const savePlans = (payload) => {
  const URL = "/plans/save";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const updatePlans = (payload) => {
  const URL = "/plans/update";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const deletePlans = (payload) => {
  const URL = "/plans/delete";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const savePlanThumbnail = (payload) => {
  const URL = "/plans/thumbnail/save";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const updatePlanThumbnail = (payload) => {
  const URL = "/plans/thumbnail/update";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const savePlanDay = (payload) => {
  const URL = "/plans/day/save";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const updatePlanDay = (payload) => {
  const URL = "/plans/day/update";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const deletePlanDay = (payload) => {
  const URL = "/plans/day/delete";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const saveRelatedPlans = (payload) => {
  const URL = "/plans/related/save";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const deleteRelatedPlans = (payload) => {
  const URL = "/plans/related/delete";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const savePlanCategory = (payload) => {
  const URL = "/plans/category/save";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const updatePlanCategory = (payload) => {
  const URL = "/plans/category/update";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const deletePlanCategory = (payload) => {
  const URL = "/plans/category/delete";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const saveCategoryPlan = (payload) => {
  const URL = "/plans/category/plan/save";
  return Axios.post(URL, payload).then((res) => res.data);
};

export const deleteCategoryPlan = (payload) => {
  const URL = "/plans/category/plan/delete";
  return Axios.post(URL, payload).then((res) => res.data);
};

// Journal Speaker Language APIs
export const saveJournalLanguageSpeaker = (payload) =>
  Axios.post("/journal/language/speaker/save", payload);
export const updateJournalLanguageSpeaker = (payload) =>
  Axios.post("/journal/language/speaker/update", payload);
export const deleteJournalLanguageSpeaker = (payload) =>
  Axios.post("/journal/language/speaker/delete", payload);

// Journal Category Language APIs
export const saveJournalLanguageCategory = (payload) =>
  Axios.post("/journal/language/category/save", payload);
export const updateJournalLanguageCategory = (payload) =>
  Axios.post("/journal/language/category/update", payload);
export const deleteJournalLanguageCategory = (payload) =>
  Axios.post("/journal/language/category/delete", payload);


// Journal Language APIs
export const saveJournalLanguage = (payload) =>
  Axios.post("/journal/language/save", payload);
export const updateJournalLanguage = (payload) =>
  Axios.post("/journal/language/update", payload);
export const deleteJournalLanguage = (payload) =>
  Axios.post("/journal/language/delete", payload);

// Journal Language Notes APIs
export const saveJournalLanguageNotes = (payload) =>
  Axios.post("/journal/language/notes/save", payload);
export const updateJournalLanguageNotes = (payload) =>
  Axios.post("/journal/language/notes/update", payload);
export const deleteJournalLanguageNotes = (payload) =>
  Axios.post("/journal/language/notes/delete", payload);

// Journal Language NoteItems APIs
export const saveJournalLanguageNoteItems = (payload) =>
  Axios.post("/journal/language/noteitems/save", payload);
export const updateJournalLanguageNoteItems = (payload) =>
  Axios.post("/journal/language/noteitems/update", payload);
export const deleteJournalLanguageNoteItems = (payload) =>
  Axios.post("/journal/language/noteitems/delete", payload);